import { DAppClient, PermissionScope } from '@airgap/beacon-sdk';
import { createTransferOperation, createOriginationOperation, createSetDelegateOperation } from '@taquito/taquito';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

var BeaconWalletNotInitialized = /** @class */ (function () {
    function BeaconWalletNotInitialized() {
        this.name = 'BeaconWalletNotInitialized';
        this.message = 'You need to initialize BeaconWallet by calling beaconWallet.requestPermissions first';
    }
    return BeaconWalletNotInitialized;
}());
var MissingRequiredScopes = /** @class */ (function () {
    function MissingRequiredScopes(requiredScopes) {
        this.requiredScopes = requiredScopes;
        this.name = 'MissingRequiredScopes';
        this.message = "Required permissions scopes were not granted: " + requiredScopes.join(',');
    }
    return MissingRequiredScopes;
}());
var BeaconWallet = /** @class */ (function () {
    function BeaconWallet(options) {
        this.client = new DAppClient(options);
    }
    BeaconWallet.prototype.getPermissionOrFail = function () {
        if (!this.permissions) {
            throw new BeaconWalletNotInitialized();
        }
        return this.permissions;
    };
    BeaconWallet.prototype.validateRequiredScopesOrFail = function (permission, requiredScopes) {
        var e_1, _a;
        var mandatoryScope = new Set(requiredScopes);
        try {
            for (var _b = __values(permission.scopes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var scope = _c.value;
                if (mandatoryScope.has(scope)) {
                    mandatoryScope.delete(scope);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (mandatoryScope.size > 0) {
            throw new MissingRequiredScopes(Array.from(mandatoryScope));
        }
    };
    BeaconWallet.prototype.requestPermissions = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var activeAccount, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getActiveAccount()];
                    case 1:
                        activeAccount = _a.sent();
                        if (activeAccount) {
                            this.permissions = activeAccount;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.client.requestPermissions(request)];
                    case 2:
                        result = _a.sent();
                        this.permissions = result;
                        return [2 /*return*/];
                }
            });
        });
    };
    BeaconWallet.prototype.removeFeeAndLimit = function (op) {
        var fee = op.fee, gas_limit = op.gas_limit, storage_limit = op.storage_limit, rest = __rest(op, ["fee", "gas_limit", "storage_limit"]);
        return rest;
    };
    BeaconWallet.prototype.getPKH = function () {
        var address = this.getPermissionOrFail().address;
        return Promise.resolve(address);
    };
    BeaconWallet.prototype.mapTransferParamsToWalletParams = function (params) {
        return createTransferOperation(params);
    };
    BeaconWallet.prototype.mapOriginateParamsToWalletParams = function (params) {
        return createOriginationOperation(params);
    };
    BeaconWallet.prototype.mapDelegateParamsToWalletParams = function (params) {
        return createSetDelegateOperation(params);
    };
    BeaconWallet.prototype.sendOperations = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var permissions, network, transactionHash;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        permissions = this.getPermissionOrFail();
                        this.validateRequiredScopesOrFail(permissions, [PermissionScope.OPERATION_REQUEST]);
                        network = permissions.network;
                        return [4 /*yield*/, this.client.requestOperation({
                                network: network,
                                operationDetails: params.map(function (op) { return (__assign({}, _this.removeFeeAndLimit(op))); }),
                            })];
                    case 1:
                        transactionHash = (_a.sent()).transactionHash;
                        return [2 /*return*/, transactionHash];
                }
            });
        });
    };
    return BeaconWallet;
}());

export { BeaconWallet, BeaconWalletNotInitialized, MissingRequiredScopes };
//# sourceMappingURL=taquito-beacon-wallet.es5.js.map
